'use client';
import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { useCMSConfig } from '@/modules/common';
import { useGetCommonStore } from '@/store';

interface usePromotionsMenuDataParams {
  locale: string;
  disableOnMobile?: boolean;
}

export const usePromotionsMenuData = ({
  locale,
  disableOnMobile,
}: usePromotionsMenuDataParams) => {
  const useCommonStore = useGetCommonStore();

  const isMobileDevice = useCommonStore.use.isMobileDevice();

  const {
    fetchScratchGameMenuData,
    fetchBonanzaPromoMenuData,
    fetchFortuneWheelMenuData,
    fetchDiceRollMenuData,
  } = useCommonStore(
    useShallow((state) => ({
      fetchScratchGameMenuData: state.fetchScratchGameMenuData,
      fetchBonanzaPromoMenuData: state.fetchBonanzaPromoMenuData,
      fetchFortuneWheelMenuData: state.fetchFortuneWheelMenuData,
      fetchDiceRollMenuData: state.fetchDiceRollMenuData,
    }))
  );

  const { cmsConfig } = useCMSConfig();

  useEffect(() => {
    if (!cmsConfig || (disableOnMobile && isMobileDevice)) return;

    if (cmsConfig.bonanzaPromo.availableByDate) {
      fetchBonanzaPromoMenuData(locale);
    }

    if (cmsConfig.scratchGame.availableByDate) {
      fetchScratchGameMenuData(locale);
    }

    if (cmsConfig.fortuneWheel.availableByDate) {
      fetchFortuneWheelMenuData(locale);
    }

    if (cmsConfig.diceRoll.availableByDate) {
      fetchDiceRollMenuData(locale);
    }
  }, [
    locale,
    cmsConfig,
    isMobileDevice,
    disableOnMobile,
    fetchDiceRollMenuData,
    fetchScratchGameMenuData,
    fetchBonanzaPromoMenuData,
    fetchFortuneWheelMenuData,
  ]);
};
